import { Injectable, Signal, signal } from '@angular/core';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly _isVisible = signal<boolean>(false);

  readonly isVisible: Signal<boolean> = this._isVisible.asReadonly();

  constructor(private localStorageService: LocalStorageService) {
    const stored = this.localStorageService.get('MostrarHeader');
    this._isVisible.set(stored === 'true');
  }

  setVisible(value: boolean): void {
    this._isVisible.set(value);
    this.localStorageService.add('MostrarHeader', value ? 'true' : 'false');
  }
}
